import { useItemFunctionMenuItemsType } from '../../../../../Utils/ObjektVyUtils';

import { useContext, useMemo } from 'react';
import { ActiveDatabaseContext } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { useBusinessConfig } from '../../../../../Components/BusinessConfigContext/BusinessConfigContext';
import { useDeleteFunctionMenuItem } from '../../../../../Hooks/useDeleteItem';
import { isReadOnlyRutin } from './Utils/AktivitetUtils';
import { useQuery } from '@apollo/client';
import {
  MeQuery,
  MeQueryVariables,
} from '../../Rutiner/Kalender/Queries/MeQuery/_QueryTypes/MeQuery';
import meQuery from '../../Rutiner/Kalender/Queries/MeQuery/MeQuery.gql';

export const getUseAktivitetFunktionsMenyItems = (
  isAktivityView: boolean | undefined
) => {
  const useAktivitetFunktionsMenyItems: useItemFunctionMenuItemsType =
    input => {
      const databaseContext = useContext(ActiveDatabaseContext);
      const availableRoutines = databaseContext.availableRoutines;

      const { activeDatabase } = useContext(ActiveDatabaseContext);

      const activeDatabaseOptions = useMemo(
        () => ({
          variables: {
            dbname: activeDatabase ?? 'noDBYet',
          },
          skip: !activeDatabase,
        }),
        [activeDatabase]
      );
      const { data: me_data } = useQuery<MeQuery, MeQueryVariables>(
        meQuery,
        activeDatabaseOptions
      );

      const currentBookingGroup = input?.item?._Associations?.Bokningsgrupp;

      let collectionPart = input.associationName
        ? `${input.associationName}/`
        : '';
      let baseUrl = window.location.href;
      if (baseUrl.slice(-1) !== '/') {
        baseUrl = `${baseUrl}/`;
      }
      const url = `${baseUrl}${collectionPart}${input.id}/`;

      const match = me_data?.me?.[0]?.bokningsgrupper?.some(
        x => x?.namn === currentBookingGroup?.BENAMNING
      );

      const businessConfig = useBusinessConfig(
        input.collection?.CollectionName
      );

      const deleteFunctionMenuItem = useDeleteFunctionMenuItem(
        input,
        businessConfig
      );

      return isAktivityView
        ? [
            {
              id: 'Öppna i ny flik',
              caption: 'Öppna i ny flik',
              onClick: () => {
                if (input.collection) {
                  window.open(url, '_blank');
                }
              },
              iconType: 'open_in_new',
            },
            input?.item?._typ === 'AKTOVRIGT' ||
            input?.item?._typ === 'GUDSTJANST'
              ? isReadOnlyRutin('rtnWebKalender', availableRoutines)
                ? {
                    ...deleteFunctionMenuItem,
                    disabled: true,
                    disabledReason: `Ingen behörighet att redigera aktiviteten`,
                    id: 'aktivitetDelete',
                    hidden: !businessConfig?.userDeleteable && false,
                  }
                : match === false
                ? {
                    ...deleteFunctionMenuItem,
                    disabled: true,
                    disabledReason: `Du är inte behörig att ta bort denna aktivitet. Behörighet att boka, att boka gudstjänster, eller till bokningsgrupp ${currentBookingGroup?.BENAMNING} krävs`,
                    id: 'aktivitetDelete',
                    hidden: !businessConfig?.userDeleteable && false,
                  }
                : !(
                    me_data?.me?.[0]?.userCanEditBooking ||
                    input?.item?.BOKNINGSSIGNATUR === me_data?.me?.[0]?.sign
                  )
                ? {
                    ...deleteFunctionMenuItem,
                    disabled: true,
                    disabledReason: `Saknar behörighet att ta bort aktiviteten`,
                    id: 'aktivitetDelete',
                    hidden: !businessConfig?.userDeleteable && false,
                  }
                : {
                    ...deleteFunctionMenuItem,
                    disabled: false,
                    disabledReason: undefined,
                    id: 'aktivitetDelete',
                    hidden: !businessConfig?.userDeleteable && false,
                  }
              : {
                  ...deleteFunctionMenuItem,
                  disabled: true,
                  disabledReason:
                    'Endast aktiviteter med typen "övrigt" eller "gudstjänst" kan tas bort',
                  id: 'aktivitetDelete',
                  hidden: !businessConfig?.userDeleteable && false,
                },
          ]
        : [
            input?.item?._typ === 'AKTOVRIGT' ||
            input?.item?._typ === 'GUDSTJANST'
              ? isReadOnlyRutin('rtnWebKalender', availableRoutines)
                ? {
                    ...deleteFunctionMenuItem,
                    disabled: true,
                    disabledReason: `Ingen behörighet att redigera aktiviteten`,
                    id: 'aktivitetDelete',
                    hidden: !businessConfig?.userDeleteable && false,
                  }
                : match === false
                ? {
                    ...deleteFunctionMenuItem,
                    disabled: true,
                    disabledReason: `Du är inte behörig att ta bort denna aktivitet. Behörighet att boka, att boka gudstjänster, eller till bokningsgrupp ${currentBookingGroup?.BENAMNING} krävs`,
                    id: 'aktivitetDelete',
                    hidden: !businessConfig?.userDeleteable && false,
                  }
                : !(
                    me_data?.me?.[0]?.userCanEditBooking ||
                    input?.item?.BOKNINGSSIGNATUR === me_data?.me?.[0]?.sign
                  )
                ? {
                    ...deleteFunctionMenuItem,
                    disabled: true,
                    disabledReason: `Saknar behörighet att ta bort aktiviteten`,
                    id: 'aktivitetDelete',
                    hidden: !businessConfig?.userDeleteable && false,
                  }
                : {
                    ...deleteFunctionMenuItem,
                    disabled: false,
                    disabledReason: undefined,
                    id: 'aktivitetDelete',
                    hidden: !businessConfig?.userDeleteable && false,
                  }
              : {
                  ...deleteFunctionMenuItem,
                  disabled: true,
                  disabledReason:
                    'Endast aktiviteter med typen "övrigt" eller "gudstjänst" kan tas bort',
                  id: 'aktivitetDelete',
                  hidden: !businessConfig?.userDeleteable && false,
                },
          ];
    };

  return useAktivitetFunktionsMenyItems;
};
